export enum IdentityProvider {
  Google = 0,
  Microsoft = 1,
  EmailAndPassword = 2,
}
